import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import { humanizeDateIST } from "../../../../utils/time-format";
import { VikatanResponsiveContainer, VikatanResponsiveContainerLiveblog } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import styles from "../text-story-page/styles.m.css";
import stylesPA from "./styles.m.css";
import { ScrollPercentage } from "react-scroll-percentage";

import Icon from "../../../../atoms/icon";
import { Link } from "@quintype/components";
import { fetchvuuklegetCommentCount } from "../../../../../api";

function LiveBlogStory(props) {
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const isClosed = get(props, ["story", "metadata", "is-closed"], false);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyIndex = get(props, ["index"], 0);
  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;
  const cardLength = cards.length;
  const storyId = get(props, ["story", "id"], "");
  const [commentsCount, setCommentsCount] = useState(null);
  const expandComments = get(props, ["expandComments"], () => null);
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);

  const [showShare, setShowShare] = useState(false);

  // const [showIplArticleBanner, setShowIplArticleBanner] = useState(false);
  const [Percentage, setPercentage] = useState(0);

  // useEffect(() => {
  //   const checkDomain = () => {
  //     const allowedDomain = "sports.vikatan.com";
  //     const hostname = global.location.hostname || "";
  //     setShowIplArticleBanner(hostname === allowedDomain);
  //   };

  //   checkDomain();
  // }, []);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  useEffect(
    () => {
      GetStoryScrollPercentage(Percentage);
    },
    [Percentage]
  );

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const iplArticleBanner = showIplArticleBanner ? (
  //   <div className={styles["ipl-article-banner"]}>
  //     <div className="hidden-mobile">
  //       <a href="https://sports.vikatan.com/olympics?utm_source=story_banner" rel="noopener noreferrer" target="_blank">
  //         <img
  //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_700x120.png"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //     <div className="hidden-desktop">
  //       <a href="https://sports.vikatan.com/olympics?utm_source=story_banner" rel="noopener noreferrer" target="_blank">
  //         <img
  //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_375x120.png"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //   </div>
  // ) : null;

  return (
    <div className="page-content">
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            {/* <div>{iplArticleBanner}</div> */}
            <Breadcrumb subSection={section} config={props.config} />
            <ScrollPercentage>
              {({ percentage, ref }) => {
                const percentageRound = percentage.toFixed(2) * 100;
                if (percentageRound) {
                  setPercentage(percentageRound);
                }
                return (
                  <div ref={ref}>
                    {renderHeaderCard()}
                    <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>
                    <VikatanResponsiveContainerLiveblog
                      placement={"text-story"}
                      story={props.story}
                      className="ad_300_250"
                    />
                    <div className={styles["hero-image-wrapper"]}>
                      <HeroImage
                        story={props.story}
                        className={styles["hero-image"]}
                        icon="liveupdate"
                        headline="Live Update"
                      />
                    </div>

                    <div className={styles["audio-share-wrapper"]}>
                      <div className={styles["audio-comments-share"]}>
                        <div>
                          <Link
                            href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles["box-div"]}
                          >
                            <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                            <span className={styles["channel-txt"]}>Join Our Channel</span>
                          </Link>
                          {/* <Link
                    href="https://bit.ly/3J0OoJc"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                    style={{ padding: "0" }}
                  >
                    <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                  </Link> */}
                        </div>

                        <div className={styles["box-div"]} onClick={scrollToComments}>
                          <Icon type="comment" />
                          <span className={styles["channel-txt"]}>
                            {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                          </span>
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                        </div>
                        <div
                          className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                          onClick={handleShareClick}
                        >
                          <Icon type="socialshare" />
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                        </div>
                      </div>

                      <div className={styles["social-share-wrapper"]}>
                        {showShare && !readMore && renderSocialMedia("", false)}
                      </div>
                    </div>

                    {cards &&
                      cards.map((card, index) => {
                        return (
                          <div className={stylesPA["card-wrapper"]} key={card.id}>
                            <timestamp className={stylesPA["timestamp"]}>
                              {isClosed
                                ? humanizeDateIST(card["card-added-at"], "absolute")
                                : humanizeDateIST(card["card-added-at"])}
                            </timestamp>
                            <div className="live-blog-card">
                              <StoryCard
                                card={card}
                                story={props.story}
                                showCard={readMore}
                                index={index}
                                storyIndex={storyIndex}
                                cardLength={cardLength}
                                config={props.config}
                              />
                            </div>
                            <VikatanResponsiveContainer
                              adtype={parseInt(index + 1)}
                              placement={"text-story"}
                              storyId={props.story.id}
                              className="ad_300_250"
                              story={props.story}
                            />
                            {index === 1 && (
                              <div>
                                <StoryMidPromotion story={props.story} />
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                );
              }}
            </ScrollPercentage>
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>

            <div id="we-story-end" />
          </article>
          {renderFooter(readMore)}
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,

  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
LiveBlogStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { LiveBlogStory };
